import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Navbar = ({ activeCategory, onCategoryClick, isDarkMode }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const menuCategories = t('menu', { returnObjects: true });

  useEffect(() => {
    const el = document.getElementById(`nav-${activeCategory}`);
    const container = containerRef.current;
    if (el && container) {
      const containerWidth = container.offsetWidth;
      const elLeft = el.offsetLeft;
      const elWidth = el.offsetWidth;
      const scrollPosition = elLeft - (containerWidth / 2) + (elWidth / 2);
      
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }, [activeCategory]);

  // ألوان النافبار حسب الوضع
  const navStyles = {
    dark: {
      background: '#000000',
      borderBottom: 'solid 1px #FFC107',
      activeBg: '#FFC107',
      activeText: '#000000',
      inactiveText: '#FFC107',
      hoverBg: '#1a1a1a'
    },
    light: {
      background: '#ffffff',
      borderBottom: 'solid 1px #e67e22',
      activeBg: '#e67e22',
      activeText: '#ffffff',
      inactiveText: '#e67e22',
      hoverBg: '#f8f9fa'
    }
  };

  const currentStyle = isDarkMode ? navStyles.dark : navStyles.light;

  const navLinkClass = (key) => 
    `nav-link px-3 py-2 ${activeCategory === key ? 'active-nav rounded-3' : ''}`;

  // دوال السحب بالماوس
  const startDrag = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const endDrag = () => setIsDragging(false);

  const whileDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // زيادة السرعة
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="px-0 sticky-top" style={{ 
      top: '60px', 
      zIndex: 1000, 
      background: currentStyle.background,
      borderBottom: currentStyle.borderBottom
    }}>
      <nav className="container navbar py-0" style={{ background: currentStyle.background }}>
        <div
          ref={containerRef}
          className="d-flex gap-2 pt-3 px-3 overflow-auto hide-scrollbar"
          style={{ 
            cursor: isDragging ? 'grabbing' : 'grab',
            background: currentStyle.background
          }}
          onMouseDown={startDrag}
          onMouseLeave={endDrag}
          onMouseUp={endDrag}
          onMouseMove={whileDrag}
        >
          {Object.keys(menuCategories).map((key) => (
            <a
              key={key}
              id={`nav-${key}`}
              className={navLinkClass(key)}
              href={`#${key}`}
              onClick={(e) => {
                e.preventDefault();
                onCategoryClick(key);
              }}
              style={{ 
                minWidth: 'fit-content',
                whiteSpace: 'nowrap',
                background: activeCategory === key ? currentStyle.activeBg : 'transparent',
                color: activeCategory === key ? currentStyle.activeText : currentStyle.inactiveText,
                fontWeight: 'bold',
                transition: 'all 0.3s ease',
                border: activeCategory === key ? `1px solid ${currentStyle.activeBg}` : `1px solid transparent`
              }}
              onMouseEnter={(e) => {
                if (activeCategory !== key) {
                  e.target.style.background = currentStyle.hoverBg;
                  e.target.style.border = `1px solid ${currentStyle.inactiveText}`;
                }
              }}
              onMouseLeave={(e) => {
                if (activeCategory !== key) {
                  e.target.style.background = 'transparent';
                  e.target.style.border = '1px solid transparent';
                }
              }}
            >
              {menuCategories[key]}
            </a>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;